var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([
		__webpack_require__.e(7133),
		__webpack_require__.e(6886)
	]).then(next);
};